import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db, orderAuth } from '../firebase';

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser]         = useState(null);
  const [role, setRole]         = useState(null);
  const [userName, setUserName] = useState('');
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    return onAuthStateChanged(auth, async (fu) => {
      if (fu) {
        const snap = await getDoc(doc(db, 'users', fu.uid));
        if (snap.exists()) {
          setRole(snap.data().role);
          setUserName(snap.data().name);
        } else {
          // No profile found for this UID — reset instead of keeping stale role
          setRole(null);
          setUserName('');
        }
        setUser(fu);
      } else {
        setUser(null);
        setRole(null);
        setUserName('');
      }
      setLoading(false);
    });
  }, []);

  const login = async (email, pw) => {
    const cred = await signInWithEmailAndPassword(auth, email, pw);
    // Also sign in (same email/password) to the website-orders project so its rules can require a signed-in staff member.
    // Optional: if that account doesn't exist there, billing still works.
    signInWithEmailAndPassword(orderAuth, email, pw).catch(() => {});
    return cred;
  };
  const logout = () => { signOut(orderAuth).catch(() => {}); return signOut(auth); };

  const can = (feature) => {
    const perms = {
      admin:   ['dashboard','billing','orders','inventory','recipes','consumption','loyalty','users','online-orders','reports','admin-panel'],
      manager: ['dashboard','billing','orders','inventory','recipes','consumption','loyalty','online-orders','reports'],
      cashier: ['dashboard','billing','orders','inventory','online-orders'],
      kitchen: ['orders','online-orders'],
    };
    return (perms[role] || []).includes(feature);
  };

  return (
    <AuthContext.Provider value={{ user, role, userName, loading, login, logout, can }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}